import React, { useState } from "react";
import { Button, Tooltip,  } from 'antd';
import notification from '../../services/notification';
import { FormattedMessage, useIntl, } from "react-intl";
import { Printer, } from "@phosphor-icons/react";
import { InvoiceDownload } from '../../services/invoices';

const DownloadButton = ({
    invoiceID,
    customerID,
    disableButton = false,
    hidden = false,
    history,
    size = "small",
    ...props
}) => {

    const [buttonIsDisabled, setIsButtonDisabled] = useState(disableButton);
    const intl = useIntl();
    // const [downloadActive, setDownloadActive] = useState(false);

    const downloadInvoice = () => {
        setIsButtonDisabled(true);
        // setDownloadActive(true);

        const postdata = { customer_id: customerID, invoice_id: invoiceID };

        InvoiceDownload(postdata, history)
            .then(response => {
                if (response.status) {

                    downloadBase64(response.data.base64, "factuur.pdf");

                    // download item from recived link
                    // var element = document.createElement('a');
                    // element.setAttribute('href', response.data.url);
                    // document.body.appendChild(element);
                    // element.click();

                    // cleanup after a small delay
                    setTimeout(() => {
                        //     document.body.removeChild(element);
                        setIsButtonDisabled(false);
                        //     // setDownloadActive(false);
                    }, 500);

                } else {
                    setIsButtonDisabled(false);
                    notification['error']({
                        message: 'Download invoice',
                        description: intl.formatMessage({ id: response.msg }),
                    });
                    // setDownloadActive(false);
                }
            })
            .catch(error => { });
    };

    const downloadBase64 = (base64String, fileName) => {
        // Convert the base64 string to a Uint8Array
        const binaryString = atob(base64String);
        const binaryData = new Uint8Array(binaryString.length);

        for (let i = 0; i < binaryString.length; i++) {
            binaryData[i] = binaryString.charCodeAt(i);
        }

        // Create a Blob from the binary data
        const blob = new Blob([binaryData], { type: 'application/octet-stream' });

        // Create a download link
        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = fileName;

        // Simulate a click on the download link
        document.body.appendChild(downloadLink);
        downloadLink.click();

        // Clean up
        setTimeout(() => {
            document.body.removeChild(downloadLink);
            URL.revokeObjectURL(downloadLink.href);
        }, 500);
    };


    return (
        <Tooltip placement="top" title={<FormattedMessage id="invoice-download-tt" />}>
            <Button
                size={size}
                hidden={hidden}
                onClick={event => { downloadInvoice(); event.stopPropagation() }}
                disabled={buttonIsDisabled}
                loading={buttonIsDisabled}
                icon={<Printer size={16} weight="fill" color="#5c5c5c" />}
                className="mr-1">
            </Button>
        </Tooltip>
    )
};

export default DownloadButton;